var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.percent + '%', backgroundColor: _vm.color })})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }